import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowLeftIcon, HomeIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouPage() {
  const {
    t,
    getPath
  } = useLanguage();
  return <div className="min-h-screen flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-523">
      <Navigation data-id="element-524" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-525">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-526">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-527">
            <CheckCircleIcon className="w-12 h-12 text-white" data-id="element-528" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-529">
            Thank you!
          </h1>

          <p className="text-lg mb-8" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-530">
            Your request has been received. We'll get back to you within 24
            hours with your free website preview.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-531">
            <a href={getPath('')} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-532">
              <HomeIcon className="w-5 h-5" data-id="element-533" />
              Back to Home
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-534" />
    </div>;
}